import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { AddUserDialogComponent } from '../../../user-management/add-user-dialog/add-user-dialog.component';
import { GenericFilter } from 'shared';
import { TenantGroupRoleDto } from 'shared';

@Component({
    selector: 'assign-tenant-grouprole-dialog',
    templateUrl: './assign-tenant-grouprole-dialog.component.html',
    styleUrls: ['./assign-tenant-grouprole-dialog.component.css'],
    standalone: false
})
export class AssignTenantGrouproleDialogComponent implements OnInit {

  filter: GenericFilter = new GenericFilter();
  groupRoles:TenantGroupRoleDto[] = [];
  TGRForm!: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<AddUserDialogComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any, // flag: vorher kein User vorhanden (wird nicht verwendet)
     public translate: TranslateService,
     private notificationService: NotificationService,
     //private platformGroupRoleService: PlatformGroupRoleService,
     private tenantService: TenantService,
     private oauthService: OAuthServiceService) { }

  ngOnInit() {
    //this.filter = new GenericFilter();
    this.tenantService.getTenantGroupRoles(this.tenantService.tempTenantName, this.filter).subscribe({
       next:(groupRoleDtos:any) => { 
        console.log("------> tenantGroupRoles: ", groupRoleDtos)
        this.groupRoles = groupRoleDtos;
        // this.subSquirrels = groupRoleDtos.item2;
      }
    })
    this.createTGRForm();

  }

  createTGRForm() {

    let roles:TenantGroupRoleDto[] = [];
    this.TGRForm = this.formBuilder.group({
      userRoles:[roles],
    });

  }
  cancel() {
    this._dialogRef.close();
  }

  add() {
    if (this.TGRForm.valid) {
      //console.log("=========> user form value", this.userForm.value)
      let userData = {userDto: this.TGRForm.value};
      // let data = {userDto: this.userForm.value, subSquirrels: this.subSquirrels};
      // this._dialogRef.close(this.userForm.value);
      // if(!this.data)
        this._dialogRef.close(userData);
      // else
      //   this._dialogRef.close(true);
    }
    else{
      this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    }
  }


}
